import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../auth/auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private _snackBar: MatSnackBar, private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get the JWT token from local storage
    const token = localStorage.getItem('jwt_token');

    // If the token exists, add it to the Authorization header
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // Continue with the modified request
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Handle 401 Unauthorized response here
          // For example, redirect the user to the login page or refresh the token
          this._snackBar.open('Session abgelaufen - bitte erneut einloggen', 'Schließen', {duration: 3000});
          // Redirect to login page or refresh token logic here...
          this.authService.logout();
        }
        return throwError(() => error);
      })
    );
  }
}
